<template>
    <section class="c-text-box">
        <div class="container">
            <h1 v-if="heading && headingTag === 'h1'" class="section-heading" :class="{'seo-only': hasSeoOnly}">
                {{ heading }}
            </h1>
            <h2 v-else-if="heading" class="section-heading" :class="{'seo-only': hasSeoOnly}">
                {{ heading }}
            </h2>
            <div class="box-text" :class="{closed: !full}">
                <!-- eslint-disable-next-line vue/no-v-html -->
                <span v-html="showText" />
                <span class="read-more" v-if="!full && text.length > 600" @click="full=true">بیشتر بخوانید</span>
                <template v-if="img">
                    <br>
                    <img :src="$image(img.url)" :alt="img.alt" class="img">
                </template>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: '',
        },
        heading: {
            type: String,
            default: '',
        },
        full: {
            type: Boolean,
            default: false,
        },
        img: {
            type: Object,
            default: null,
        },
        hasSeoOnly: {
            type: Boolean,
            default: false,
        },
        headingTag: {
            type: String,
            default: 'h2',
        },
    },
    computed: {
        showText () {
            if (this.full) {
                return this.text;
            }
            return this.text.length < 600 ? this.text : this.text.substr(0, 600) + ' ... ';
        },
    },
};
</script>

<style scoped lang="scss">
    @import '~vars';

    .c-text-box {
        padding: 63px 0 57px;

        .box-text {
            font-size: 1em;
            line-height: 30px;
            font-weight: 300;
            color: $gray-darker;
            text-align: justify;
            transition: height 1s;

            &.closed {
                @media (min-width: 768px) {
                    max-height: 150px;
                }
                @media (min-width: 992px) {
                    max-height: 120px;
                }
            }

            span.read-more {
                font-weight: bold;

                &:hover {
                    cursor: pointer;
                }
            }

            img.img {
                width: 100%;
            }
        }
    }
</style>
